import { Box, Button, Typography } from '@mui/material';

import React from 'react';

const ContactAdmin: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Typography variant="h4" gutterBottom>
        No Permissions
      </Typography>
      <Typography variant="body1" paragraph>
        You currently don't have any permissions to access the system.
      </Typography>
      <Typography variant="body1" paragraph>
        Please contact the administrator to request access.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href="mailto:developer@keeta.net"
      >
        Contact Admin
      </Button>
    </Box>
  );
};

export default ContactAdmin;